import {Cart} from "../../../../../assets/icons/Cart";
import {ExclamationPoint} from "../../../../../assets/icons/ExclamationPoint";
import React from "react";
import './call-badges.scss'

const DraftOrderAbandoned = () => {
  return (
    <span className='call-outcome abandoned'>
      <Cart />
      <p className='draft-order-nowrap'>Draft order</p>
      <span className='alert-point-container'>
        <ExclamationPoint />
      </span>
    </span>
  )
}

export default DraftOrderAbandoned;